/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { toast } from 'react-toastify'

import axios, { AxiosInstance } from 'axios'
import http from 'http'
import https from 'https'
import jwtDecode from 'jwt-decode'

import { ApiErro, getApiError, obterMensagensDaApi } from './api-erro'

let gatewayApi: AxiosInstance
const httpAgent = new http.Agent({ keepAlive: true })
const httpsAgent = new https.Agent({ keepAlive: true })

export { getApiError }

const toastarErroDaApi = (axiosError: ApiErro) => {
  const status = axiosError.response?.status

  obterMensagensDaApi(axiosError).then(mensagens => {
    if (mensagens.length > 0) {
      for (const mensagem of mensagens) {
        toast(mensagem, {
          type: 'error'
        })
      }
      return
    }

    toast(`Não foi possível salvar os dados (HTTP ${status})`, {
      type: 'error'
    })
  })
}

// A claim so existe em tokens de impersonate; usuarios/tokens normais nao a tem.
const tokenEDeImpersonate = (token: string): boolean => {
  try {
    return jwtDecode<{ impersonated?: string }>(token)?.impersonated === 'true'
  } catch {
    return false
  }
}

const instanciarApi = (
  baseURL: string,
  token: string,
  sair: (semRedirecionamento?: boolean) => Promise<void>
) => {
  const instancia = axios.create({
    baseURL,
    responseType: 'json',
    httpAgent,
    httpsAgent
  })

  instancia.defaults.headers.Authorization = `Bearer ${token}`

  const impersonando = token ? tokenEDeImpersonate(token) : false

  instancia.interceptors.response.use(
    respostaApi => respostaApi,
    erro => {
      const axiosError = erro as ApiErro
      if (axiosError.isAxiosError) {
        switch (axiosError.response?.status) {
          case 400:
          case 500:
            toastarErroDaApi(axiosError)
            break
          case 401:
            if (window.location.pathname !== '/entrar') {
              sair(!!window.location.pathname.startsWith('/matricula'))
            }
            break
          case 403:
            // Durante uma sessao de impersonate, 403 e o comportamento
            // esperado (FiltroDeImpersonation bloqueando escrita, ou o
            // usuario-alvo sem a role exigida) - nao e uma falha de sessao,
            // entao nao redireciona, so mostra a mensagem em toast. Fora de
            // impersonate, mantem o redirecionamento de sempre. O erro segue
            // propagado (throw abaixo) para quem chamou tratar, se quiser.
            if (impersonando) {
              toastarErroDaApi(axiosError)
            } else {
              window.location.href = '/403'
            }
            break
          default:
            break
        }
      }
      throw erro
    }
  )

  return instancia
}

const criar = (
  token: string,
  sair: (semRedirecionamento?: boolean) => Promise<void> | undefined
) => {
  gatewayApi = instanciarApi(
    `${process.env.REACT_APP_URL_GATEWAY}/api`,
    token,
    sair
  )
}

export { criar, gatewayApi }
